import { motion } from "framer-motion";

export default function PageShell({ children, testid }) {
    return (
        <motion.main
            data-testid={testid}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -12 }}
            transition={{ duration: 0.25, ease: "easeOut" }}
            className="mx-auto w-full max-w-6xl px-4 pb-16 pt-8 sm:px-6 lg:px-10 lg:pt-10"
        >
            {children}
        </motion.main>
    );
}
